import React, { useEffect } from "react"

import { MainContainer } from "components/main-container"
import Grid, { Col } from "components/grid"
import { H3, Paragraph } from "components/text"
import { BackLink } from "components/text/links/back-link"
import { BorderBox } from "components/page-elements"
import { Box } from "components/box"
import { SupportEmailLink } from "components/support-links"

import { MessageList, MessageDoctor } from "./components"
import { Toolbar } from "../components"

import { useAssertValidRootQuery } from "graphql/smart-queries/user"
import { useReadDoctorMessages } from "graphql/mutations/readDoctorMessages"
import { GraphQLError } from "shared/apollo/graphql-error"
import { baseRoutes } from "routes"

const DoctorMessaging = () => {
  const { user } = useAssertValidRootQuery()
  const [readDoctorMessages, { error }] = useReadDoctorMessages()
  const { consultation } = user

  useEffect(() => {
    function markMessagesAsRead() {
      if (consultation && consultation.unreadDoctorMessagesCount > 0) {
        readDoctorMessages({
          variables: {
            consultationId: consultation.id
          }
        })
      }
    }

    markMessagesAsRead()
  }, [])

  return (
    <MainContainer
      mainContent={
        <>
          <Toolbar doctorExists />
          <Grid rowProps={{ justifyContent: "center" }} pt={[4, 4, 8, 8]} pb={7} noGutter>
            <Col cols={[4, 4, 11, 9]}>
              <Box mb={5}>
                <BackLink to={baseRoutes.dashboard()} text={<Paragraph bold>Dashboard</Paragraph>} />
              </Box>

              {error && (
                <Box my={3}>
                  <GraphQLError error={error} />
                </Box>
              )}

              {consultation && consultation.doctor ? (
                <>
                  <H3>Questions or concerns?</H3>
                  <Paragraph mt={3}>
                    Your doctor is available to answer any questions about your treatment plan. For questions regarding
                    billing, shipping, or delivery status, please reach out to our customer care team at{" "}
                    <SupportEmailLink />.
                  </Paragraph>

                  <BorderBox px={[0, 0, 5, 5]} mt={5}>
                    <MessageDoctor consultation={consultation} />

                    <Box p={[0, 0, 7, 7]} mt={4} mb={[6, 6, 9, 9]}>
                      <MessageList messages={consultation.consultationMessages} />
                    </Box>
                  </BorderBox>
                </>
              ) : (
                <Paragraph>Doctor is not assigned yet</Paragraph>
              )}
            </Col>
          </Grid>
        </>
      }
    />
  )
}

export default DoctorMessaging
